var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBirth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 .5c5.385 0 10.26 2.183 13.789 5.711A19.439 19.439 0 0 1 39.5 20c0 5.385-2.183 10.26-5.711 13.789A19.439 19.439 0 0 1 20 39.5a19.439 19.439 0 0 1-13.789-5.711A19.439 19.439 0 0 1 .5 20c0-5.385 2.183-10.26 5.711-13.789A19.439 19.439 0 0 1 20 .5z",
    stroke: "#ECECEC",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#3D3D3D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.594 13.625H9.406v-2.11c0-.387.316-.703.703-.703h.704v.704a.703.703 0 0 0 1.406 0v-.703h2.86v.703a.703.703 0 0 0 1.405 0v-.703h2.813v.703a.703.703 0 0 0 1.406 0v-.703h2.813v.703a.703.703 0 0 0 1.406 0v-.703h2.86v.703a.703.703 0 0 0 1.406 0v-.703h.703c.387 0 .703.315.703.703v2.109zm0 16.266a.704.704 0 0 1-.703.703H10.109a.704.704 0 0 1-.703-.703V15.03h21.188v14.86zM29.89 9.406h-.703v-.703a.703.703 0 0 0-1.407 0v.703h-2.86v-.703a.703.703 0 0 0-1.405 0v.703h-2.813v-.703a.703.703 0 0 0-1.406 0v.703h-2.813v-.703a.703.703 0 0 0-1.406 0v.703h-2.86v-.703a.703.703 0 0 0-1.405 0v.703h-.704c-1.163 0-2.109.947-2.109 2.11V29.89C8 31.054 8.946 32 10.11 32h19.78c1.164 0 2.11-.946 2.11-2.11V11.517c0-1.163-.946-2.11-2.11-2.11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.516 27.781h-7.032v-2.11c0-.387.316-.702.703-.702h5.625c.388 0 .704.315.704.703v2.11zm-4.175-8.028.659-1.15.659 1.15a.704.704 0 1 1-1.318 0zm6.284 8.028h-.703v-2.11c0-1.162-.946-2.108-2.11-2.108h-2.109v-1.575A2.113 2.113 0 0 0 22.11 20c0-.357-.102-.721-.206-.905l-1.293-2.257a.703.703 0 0 0-1.22 0l-1.293 2.257c-.103.18-.206.543-.206.905 0 .917.587 1.698 1.406 1.988v1.575h-2.11c-1.163 0-2.109.946-2.109 2.109v2.11h-.703a.703.703 0 0 0 0 1.406h11.25a.703.703 0 0 0 0-1.407z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirth);
export default __webpack_public_path__ + "static/media/birth.e8085d43e54036290f8597b8e943c62e.svg";
export { ForwardRef as ReactComponent };